import React from 'react'
import Skeleton from 'react-loading-skeleton'

const BlogItemSkeleton = () => {
  return (
    <div className="flex flex-col h-full relative border border-[#ededed] rounded-md p-5 bg-white transition-all duration-300 hover:border-gray-300 hover:shadow-sm">
      <div className="relative h-full">
        {/* Blog image skeleton */}
        <div className="h-[320px] md:h-[192px] w-full mb-5 flex justify-center">
          <Skeleton
            height="100%"
            width="100%"
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-md"
          />
        </div>

        {/* Blog title skeleton */}
        <div className="mb-3">
          <Skeleton
            height={18}
            width="85%"
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="mb-2 !rounded-sm"
          />
          <Skeleton
            height={18}
            width="65%"
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
        </div>

        {/* Blog description skeleton */}
        <div className="mb-8">
          <Skeleton
            count={3}
            height={15}
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="mb-1 !rounded-sm"
          />
          <Skeleton
            height={15}
            width="55%"
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
          <Skeleton
            height={15}
            width="55%"
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
          <Skeleton
            height={15}
            width="55%"
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
          <Skeleton
            height={15}
            width="55%"
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
        </div>

        {/* Blog meta info skeleton (category and time) */}
        <div className="absolute bottom-0 w-full flex justify-between items-center">
          <Skeleton
            width={75}
            height={13}
            baseColor="#e5e7eb"
            highlightColor="#f3f4f6"
            className="!rounded-sm"
          />
          <Skeleton
            width={95}
            height={13}
            baseColor="#e5e7eb"
            highlightColor="#f3f4f6"
            className="!rounded-sm"
          />
        </div>
      </div>
    </div>
  )
}

export default BlogItemSkeleton
